import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { applyFrontendChoice } from './app/core/new-app-switch';

if (environment.production) {
  enableProdMode();
}

// Skip bootstrapping when redirecting to the new frontend, so the classic app doesn't flash.
if (!applyFrontendChoice()) {
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}
